import { useEffect, type ReactNode } from 'react';
import { ToastProvider, useToast } from '@/shared/context/ToastContext';
import { CurrencyProvider } from '@/shared/context/CurrencyContext';
import { registerToastHandler } from '@/utils/handleErrorApi';

function ToastBridge({ children }: { children: ReactNode }) {
  const { showToast } = useToast();
  useEffect(() => {
    registerToastHandler(showToast);
  }, [showToast]);
  return <>{children}</>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <CurrencyProvider>
        <ToastBridge>{children}</ToastBridge>
      </CurrencyProvider>
    </ToastProvider>
  );
}
